// 6-color rotation modelled on typical Spanish youth-tournament cartels
// (green / orange / yellow / orange / red / orange in the reference Excel).
const FALLBACK_PALETTE = [
  { bg: "#7ED957", fg: "#062a00" }, // green
  { bg: "#F4A24E", fg: "#3a1f00" }, // orange
  { bg: "#F8E16C", fg: "#3a2e00" }, // yellow
  { bg: "#F4A24E", fg: "#3a1f00" }, // orange
  { bg: "#E5675A", fg: "#3a0a00" }, // red
  { bg: "#F4A24E", fg: "#3a1f00" }, // orange
];

/** Returns `{ bg, fg }` for the n-th group, cycling through the fallback palette. */
export function colorPairForGroup(index) {
  const i = ((index % FALLBACK_PALETTE.length) + FALLBACK_PALETTE.length) % FALLBACK_PALETTE.length;
  return FALLBACK_PALETTE[i];
}

/** Returns just the background hex (handy when only color matters). */
export function groupColorFallback(index) {
  return colorPairForGroup(index).bg;
}

/**
 * Curated palette offered in the color picker. Includes the same cartel-style
 * accents plus a few cool tones so the user has range.
 */
export const GROUP_COLOR_PRESETS = [
  "#7ED957", // green
  "#3CB371", // sea green
  "#F4A24E", // orange
  "#F8E16C", // yellow
  "#E5675A", // red
  "#C71585", // pink
  "#6CA0DC", // blue
  "#8B5CF6", // purple
  "#0F3531", // arena (brand)
  "#D4A012", // gold (brand)
];

/** Validates and normalizes a hex color string. Returns "" if invalid. */
export function normalizeHexColor(raw) {
  if (typeof raw !== "string") return "";
  const v = raw.trim();
  if (!v) return "";
  const m = v.match(/^#?([0-9a-fA-F]{6})$/);
  if (!m) return "";
  return `#${m[1].toLowerCase()}`;
}
